import { TableRow, TableCell } from "@mui/material";
import { EnumItemModel } from "../../../api/api";

interface Props {
  item: EnumItemModel;
}

const PropertyRow: React.FC<Props> = ({ item }) => (
  <TableRow>
    <TableCell>{item?.name}</TableCell>
    <TableCell>{item?.value}</TableCell>
  </TableRow>
);

export default PropertyRow;
